/* Boonsoir 2.0 — Recepten rail: round prev/next buttons on desktop, one card per click. */
(() => {
  const mq = window.matchMedia('(min-width: 750px)');
  function init(section) {
    const rail = section.querySelector('[data-recipes-rail]');
    const nav = section.querySelector('[data-recipes-nav]');
    if (!rail || !nav || rail._recipes) return;
    rail._recipes = true;
    const prev = nav.querySelector('[data-recipes-prev]');
    const next = nav.querySelector('[data-recipes-next]');
    let frame = 0;
    const update = () => {
      frame = 0;
      const max = rail.scrollWidth - rail.clientWidth;
      const overflow = max > 4 && mq.matches;
      nav.hidden = !overflow;
      if (!overflow) return;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max - 4;
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    const step = (dir) => {
      const card = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
      const by = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rail.scrollBy({ left: by * dir, behavior: smooth ? 'smooth' : 'auto' });
    };
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    rail.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    mq.addEventListener('change', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(rail);
    update();
  }
  const run = (scope = document) => scope.querySelectorAll('.recipes').forEach(init);
  run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
